import React, { useState } from "react";
import { useParams } from "react-router";
import { UserApi } from "../../app/api/user.api";
import './Login.css'


export function Password() 
{   
    const user = UserApi();
    const { token } = useParams();

    const [inputs, setInputs] = useState({ 'resetToken' : token });
    const [status, setStatus] = useState(0);
    const [isLoading, setIsLoading] = useState(false);
    const [message, setMessage] = useState("");
    const [showPassword, setShowPassword] = useState(false);
    const [showPassword1, setShowPassword1] = useState(false);
    const [checked, setChecked] = useState(false);

    const [isSubmitted, setIsSubmitted] = useState(false);
       
    const handleInputs = ( event ) => {
      const { name , value } =  event.target ;
      setInputs( { ...inputs, [name] : value   } ) ;
    }

    const handleSubmit = async ( event ) => {
      event.preventDefault();
      setStatus(0);
      setIsLoading(true);

      if(inputs.newPassword === inputs.confirmPassword )
      { 
        try {
            const {data} = await user.updatePassword(inputs);
            setIsLoading(false);

            if( data.success ){
              setIsSubmitted(true);
            }
            else{
              setIsSubmitted(false);
              setStatus(-1);
            }
        } catch (err) { 
            setIsLoading(false);
            setIsSubmitted(false);
            setStatus(-1);
            const response = err?.response?.data;

            if (response?.message) {
              setMessage(response.message);
            } else if (Array.isArray(response?.errors) && response.errors.length > 0) {
              setMessage(response.errors[0].msg || response.errors[0]);
            } else {
              setMessage("Une erreur est survenue. Veuillez réessayer.");
            }
        }
      }
      else{ 
        setIsLoading(false);
        setIsSubmitted(false);
        setStatus(-2); 
      }
    } 


    return(

        <div className="container-fluid">
          <div className="row justify-content-center align-items-center" style={{minHeight: '100vh', backgroundColor: '#f5f5f5'}}>
            <div className="col-xl-5 col-lg-6 col-md-8 col-sm-11 col-xs-12">

                <div className="d-flex flex-column p-4 bg-white border rounded">
                    {/* Header */}
                    <div className="d-flex flex-column align-items-center">
                      <img  src='../favicon.png'  alt='logo-ortega'  style={{ maxHeight: '80px' }} />
                      <h1 className="login-title">Ortega</h1>
                    </div>
                    <p className="text-secondary text-center mb-2 px-4">
                       Formulaire de mise à jour de mot de passe.
                    </p>

                    { !isSubmitted ? (

                    <form className='p-3' onSubmit={ handleSubmit } >
                        <div className="d-flex justify-content-center">
                          {
                            isLoading && (
                              <div className="d-flex justify-content-center mb-2"> 
                                <div className="spinner-border text-green" role="status" aria-label="Chargement"></div>
                              </div>
                            )
                          }
                          {
                            status === -1 && (
                              <div className="alert alert-danger mb-2 small w-100"> { message } </div>
                            )
                          }
                          {
                            status === -2 && (
                              <div className="d-flex justify-content-center mb-3">
                                <div className="alert alert-danger">
                                  Erreur! Veuillez revoir votre mot de passe et la confirmation.
                                 </div>
                              </div>
                            )
                          } 
                        </div>
                        <div className="d-flex flex-column mb-3 w-100">
                           <label htmlFor="password" className="small text-secondary ps-2"> Nouveau mot de passe </label>
                           <div className="password-input-wrapper">
                               <input type={showPassword ? 'text' : 'password'} name="newPassword" id="password" className="input-field" placeholder="••••••••" onChange={ handleInputs } required />
                               <button type="button" className="toggle-password-btn" onClick={() => setShowPassword(!showPassword)} title={showPassword ? 'Masquer le mot de passe' : 'Afficher le mot de passe'} >
                                 <i className={`bi bi-eye${!showPassword ? '-slash' : ''}`}></i>
                               </button>
                           </div>
                        </div>
                        <div className="d-flex flex-column mb-3 w-100">
                           <label htmlFor="cpassword" className="small text-secondary ps-2"> Confirmer Mot de passe </label>
                           <div className="password-input-wrapper mb-1">
                               <input type={showPassword1 ? 'text' : 'password'} name="confirmPassword" id="cpassword" className="input-field" placeholder="••••••••" onChange={ handleInputs } required />
                               <button type="button" className="toggle-password-btn" onClick={() => setShowPassword1(!showPassword1)} title={showPassword1 ? 'Masquer le mot de passe' : 'Afficher le mot de passe'} >
                                 <i className={`bi bi-eye${!showPassword1 ? '-slash' : ''}`}></i>
                               </button>
                           </div>
                        </div>

                        <div className="d-flex gap-2 mb-3">
                            <input type="checkbox" name="name" checked={checked} onChange={(e) => setChecked(e.target.checked)} style={{ width: '20px', height: '20px' }} />
                            <span className="small text-secondary mb-1"> J'accepte les condition d'utilisation </span>
                        </div>
                              
                        {/* Login Button */}
                        <div className="d-flex">
                          <button type="submit" disabled={!checked} className="btn btn-green py-2 px-4">
                            <span> Mettre à jour </span>
                            <i className="bi bi-chevron-right ms-2"></i>
                           </button>
                        </div>
                    </form>
                    ) : (
                        <div className="text-center px-4">
                          <div className="mb-3">
                            <i className="bi bi-check-circle text-green display-1"></i>
                          </div>
                          <p className="text-secondary">
                            Mot de passe modifié avec succes
                          </p>
                          <a href="/" className="btn btn-outline-green rounded-0 px-4">
                            Retour à l'accueil <i className="bi bi-chevron-right ms-2"></i>
                          </a>
                        </div>
                    )}
                </div>

            </div>
          </div>
        </div>
    );
}